/**
 * @fileoverview added by tsickle
 * Generated from: pipes/string-pipes.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Pipe } from '@angular/core';
/**
 * Pipe to show one of a choice of strings depending on whether an array has
 * only one item or a number is not one.
 * @param arrayOrLength Either the number to use or the array
 *   whose length will be used
 * @param [pluralString] The string to show when the number is not
 *   one (default: 's')
 * @param [singularString] The string to show when the number is one
 *   (default: '')
 * \@example
 *   <!-- Both give 'bedrooms' or 'bedroom': -->
 *   bedroom{{ bedroomCount|plural }}
 *   {{ bedroomArray|plural:'bedrooms':'bedroom' }}
 */
import * as ɵngcc0 from '@angular/core';
var Plural = /** @class */ (function () {
    function Plural() {
    }
    /**
     * @param {?} arrayOrLength
     * @param {?=} pluralString
     * @param {?=} singularString
     * @return {?}
     */
    Plural.prototype.transform = /**
     * @param {?} arrayOrLength
     * @param {?=} pluralString
     * @param {?=} singularString
     * @return {?}
     */
    function (arrayOrLength, pluralString, singularString) {
        if (pluralString === void 0) { pluralString = 's'; }
        if (singularString === void 0) { singularString = ''; }
        /** @type {?} */
        var length;
        if (typeof arrayOrLength === 'number') {
            length = arrayOrLength;
        }
        else {
            length = arrayOrLength.length;
        }
        return length === 1 ? singularString : pluralString;
    };
Plural.ɵfac = function Plural_Factory(t) { return new (t || Plural)(); };
Plural.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "plural", type: Plural, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Plural, [{
        type: Pipe,
        args: [{ name: 'plural' }]
    }], function () { return []; }, null); })();
    return Plural;
}());
export { Plural };

